module.exports = __webpack_public_path__ + "@/assets/img/051-boy-23.650b09b8.svg";